<template>
  <div>
    <br />
    네이버
    <br />
    <div id="naverIdLogin">
      <div id="naverIdLogin_loginButton"></div>
    </div>
    <a id="gnbLogin" @click="logout()"></a>
    <div>{{ naverInfo }}</div>

    <br />
    카카오
    <br />

    <a id="custom-login-btn" @click="loginWithKakao()" v-show="!k_token">
      <img src="//k.kakaocdn.net/14/dn/btqCn0WEmI3/nijroPfbpCa4at5EIsjyf0/o.jpg" width="222" style="cursor: pointer" />
    </a>
    <a id="kakao-login-btn"></a>
    <p id="token-result" @click="test()">토큰 데이터 확인</p>
    <div id="logout" v-show="k_token" @click="logoutKakao()">
      카카오로그아웃
    </div>
    <div>{{ kakaoInfo }}</div>
    <br />
    페이스북
    <br />
    <div id="fbLogin" @click="flogin()" style="cursor: pointer">
      <img
        class="img"
        src="https://z-p3-scontent-gmp1-1.xx.fbcdn.net/v/t39.2365-6/17639236_1785253958471956_282550797298827264_n.png?_nc_cat=105&amp;_nc_sid=ad8a9d&amp;_nc_eui2=AeEd0PDkvxXOJ9uwi-W5j3HYDpRKUGl8lBMOlEpQaXyUE2cZRifZitSTMqFmpetVwbsWxIS_yler8ScOk30Geoa3&amp;_nc_ohc=7Am_KNUuMMcAX_xRbjo&amp;_nc_ht=z-p3-scontent-gmp1-1.xx&amp;oh=543416a0b442ff0c0d6ca31cf0df5510&amp;oe=5F35E796"
        width="400"
        alt=""
      />
    </div>

    <div id="status" />

    <div id="dumy" v-show="f_token" @click="flogout">페북 로그아웃</div>
    <div>{{ fInfo }}</div>
  </div>
</template>

<script>
import 'jquery';

let FB;
export default {
  name: 'test',
  data() {
    return {
      email: null,
      password: null,
      naverLogin: null,
      naverName: '',
      k_token: '',
      f_token: '',
      naverInfo: null,
      kakaoInfo: null,
      fInfo: null,
    };
  },
  beforeMount() {},
  mounted() {
    //네이버 js import
    this.$loadScript('http://static.nid.naver.com/js/naveridlogin_js_sdk_2.0.0.js')
      .then(() => {
        this.init();
      })
      .catch(() => {
        // Failed to fetch script
        console.log('error');
      });

    //카카오 js import
    this.$loadScript('https://developers.kakao.com/sdk/js/kakao.js')
      .then(() => {
        console.log('kakao');
      })
      .catch(() => {
        // Failed to fetch script
        console.log('error');
      });
    //토큰 확인
    this.getToken();

    //facebook
    this.$loadScript('https://connect.facebook.net/en_US/sdk.js')
      .then(() => {
        FB.init({
          appId: '656946571561316',
          status: true,
          cookie: true,
          xfbml: true,
          version: 'v2.8',
        });

        FB.AppEvents.logPageView();
      })
      .catch(() => {
        // Failed to fetch script
        console.log('error');
      });

    (function(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  },
  methods: {
    //카카오톡 로그인 클릭시
    loginWithKakao: async function() {
      let vue = this;
      let kakaoAPI = window.Kakao;
      kakaoAPI.init('b77befe54c7db6e933630f7ab296bd26');

      await kakaoAPI.Auth.login({
        success: function(authObj) {
          vue.k_token = authObj.access_token;
          kakaoAPI.API.request({
            url: '/v2/user/me',
            success: function(res) {
              console.log(res);
              vue.kakaoInfo = res;
              document.getElementById('token-result').innerHTML =
                'id :' + res.id + '<br>nickname:' + res.kakao_account.profile.nickname + '<br>email:' + res.kakao_account.email;
            },
            fail: function(error) {
              alert('login success, but failed to request user information: ' + JSON.stringify(error));
            },
          });
        },
        fail: function(err) {
          alert(JSON.stringify(err));
        },
      });
    },
    logoutKakao: function() {
      location.href =
        'https://kauth.kakao.com/oauth/logout?client_id=f37ffc50a1d23803d1b951e0e1aae2c8&logout_redirect_uri=http://localhost:3000/loginTest';
      /*if (!Kakao.Auth.getAccessToken()) {
                    alert('Not logged in.')
                    return
                }
                Kakao.Auth.logout(function () {
                    alert('logout ok\naccess token -> ' + Kakao.Auth.getAccessToken())
                })
                Kakao.API.request({
                     url: '/v1/user/unlink',
                     success: function(response) {
                         console.log(response);
                     },
                     fail: function(error) {
                         console.log(error);
                     },
                 });*/
    },
    test: function() {
      console.log(this.k_token);
    },
    logout: function() {
      this.naverLogin.logout();
      location.reload();
    },
    //네이버 로그인 초기 세팅
    init: function() {
      this.naverLogin = new window.naver.LoginWithNaverId({
        clientId: 'FGgBT_LqotxZdLg58wPJ',
        callbackUrl: 'http://localhost:3000/loginSuccess',
        isPopup: false,
        loginButton: { color: 'green', type: 3, height: 50 },
      });
      this.naverLogin.init();
      let vue = this;
      let naverLogin = this.naverLogin;
      window.addEventListener('load', function() {
        naverLogin.getLoginStatus(function(status) {
          console.log('naver stats : ' + status);
          if (status) {
            console.log(naverLogin.user);
            vue.naverInfo = naverLogin.user;
            //let name = naverLogin.user.getName();
            naverLogin.user.getId();

            //TODO 네이버 로그인 후 처리 data.naverName에 name을 넣어보고 싶습니다.
            document.getElementById('naverIdLogin_loginButton').innerHTML =
              'id:' + naverLogin.user.getId() + '<br>name:' + naverLogin.user.getName() + '<br>email:' + naverLogin.user.getEmail();
            document.getElementById('gnbLogin').innerHTML = 'logout';
          }
        });
      });
    },

    getToken: function() {
      let kakaoAPI = window.Kakao;
      const token = this.getCookie('authorize-access-token');
      if (token) {
        kakaoAPI.Auth.setAccessToken(token);
        document.getElementById('token-result').innerText = 'login success. token: ' + kakaoAPI.Auth.getAccessToken();
      }
    },
    getCookie: function(name) {
      const value = '; ' + document.cookie;
      const parts = value.split('; ' + name + '=');
      if (parts.length === 2)
        return parts
          .pop()
          .split(';')
          .shift();
    },

    statusChangeCallback: function(response) {
      console.log('statusChangeCallback');

      if (response.status === 'connected') {
        console.log(response.authResponse.accessToken);
        // Logged into your app and Facebook.
        this.getFBUserInfoAPI();
      } else if (response.status === 'not_authorized') {
        document.getElementById('status').innerHTML = 'Please log ' + 'into this app.';
      } else {
        document.getElementById('status').innerHTML = 'Please log ' + 'into Facebook.';
      }
    },
    flogin: function() {
      let vue = this;
      FB.login(
        function(response) {
          console.log(response);
          vue.f_token = response.authResponse.accessToken;
          if (response.status == 'connected') {
            vue.getFBUserInfoAPI();
          }
        },
        { scope: 'public_profile,email,user_gender,user_birthday,user_photos' },
      );
    },
    getFBUserInfoAPI: function() {
      let vue = this;
      console.log('Welcome!  Fetching your information.... ');
      FB.api('/me', { fields: 'email,gender,name' }, function(response) {
        console.log(response);
        vue.fInfo = response;
        document.getElementById('status').innerHTML = 'name:' + response.name + '<br>id:' + response.id;
        document.getElementById('fbLogin').remove();
      });
    },
    flogout: function() {
      FB.logout(function(response) {
        console.log(response);
        location.reload();
      });
    },
  },
};
</script>
